export default function AboutGuide() {
  return (
    <section id="guida" className="py-20 md:py-28 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-6 md:px-10">
        <div className="inline-flex items-center px-4 py-1.5 rounded-full bg-white border border-background-200 mb-6">
          <span className="text-foreground-600 text-sm font-semibold">Guida 2026</span>
        </div>

        <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mb-6">
          Cos&apos;&egrave; Itaobuy Spreadsheet?
        </h2>
        <p className="text-foreground-600 text-base md:text-lg leading-relaxed max-w-[720px] mb-14">
          <strong>Itaobuy Spreadsheet</strong> &egrave; uno strumento organizzato che permette agli utenti di trovare
          rapidamente prodotti, categorie e informazioni utili senza perdere tempo nella ricerca manuale.
          Con una struttura semplice e ordinata, gli utenti possono scoprire nuovi prodotti, confrontare
          alternative, analizzare informazioni e migliorare il processo di acquisto.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {[
            {
              icon: 'ri-search-eye-line',
              title: 'Ricerca pi&ugrave; veloce',
              desc: 'Trova prodotti organizzati senza effettuare centinaia di ricerche manuali.',
              img: 'https://readdy.ai/api/search-image?query=Clean%20modern%20workspace%20with%20laptop%20displaying%20search%20results%20and%20organized%20product%20grid%2C%20warm%20cream%20desk%20surface%2C%20natural%20daylight%2C%20efficient%20workflow%20concept%2C%20minimalist%20editorial%20photography%2C%20italian%20lifestyle%20aesthetic&width=400&height=280&seq=itaobuy-about-img-01&orientation=landscape',
            },
            {
              icon: 'ri-scales-3-line',
              title: 'Migliore confronto',
              desc: 'Confronta prezzi, categorie e caratteristiche in un unico posto organizzato.',
              img: 'https://readdy.ai/api/search-image?query=Elegant%20split%20screen%20comparison%20layout%20with%20two%20product%20displays%20side%20by%20side%20on%20cream%20surface%2C%20warm%20lighting%2C%20minimalist%20catalog%20photography%2C%20italian%20modern%20aesthetic%2C%20clean%20professional%20composition&width=400&height=280&seq=itaobuy-about-img-02&orientation=landscape',
            },
            {
              icon: 'ri-shield-check-line',
              title: 'Maggiore controllo',
              desc: 'Analizza informazioni dettagliate prima di prendere decisioni di acquisto.',
              img: 'https://readdy.ai/api/search-image?query=Professional%20detailed%20analysis%20concept%20with%20laptop%20showing%20data%20charts%20closeup%2C%20cream%20desk%20texture%2C%20warm%20natural%20light%2C%20focused%20work%20atmosphere%2C%20minimalist%20editorial%20photography%2C%20italian%20office%20aesthetic&width=400&height=280&seq=itaobuy-about-img-03&orientation=landscape',
            },
            {
              icon: 'ri-timer-line',
              title: 'Risparmio di tempo',
              desc: 'Utilizza dati gi&agrave; organizzati per decisioni rapide ed efficienti.',
              img: 'https://readdy.ai/api/search-image?query=Elegant%20hourglass%20and%20watch%20on%20warm%20cream%20marble%20surface%20with%20soft%20sunlight%2C%20time%20saving%20productivity%20concept%2C%20minimalist%20lifestyle%20photography%2C%20italian%20modern%20interior%2C%20clean%20sophisticated%20composition&width=400&height=280&seq=itaobuy-about-img-04&orientation=landscape',
            },
          ].map((item, i) => (
            <div key={i} className="bg-white rounded-2xl overflow-hidden border border-background-200 group hover:border-accent-200 transition-all">
              <div className="h-[140px] overflow-hidden">
                <img src={item.img} alt={item.title.replace(/&[a-z]+;/g, '')} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
              </div>
              <div className="p-5">
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-accent-100 mb-3">
                  <i className={`${item.icon} text-accent-600 text-lg`}></i>
                </div>
                <h3 className="font-heading text-base font-semibold text-foreground-950 mb-2" dangerouslySetInnerHTML={{ __html: item.title }}></h3>
                <p className="text-foreground-500 text-sm leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {[
            { value: '14+', label: 'Categorie Prodotto' },
            { value: '1000+', label: 'Prodotti Selezionati' },
            { value: '2026', label: 'Aggiornato' },
            { value: '4.8/5', label: 'Valutazione Utenti' },
          ].map((stat, i) => (
            <div key={i} className="text-center">
              <p className="font-heading text-3xl md:text-4xl font-bold text-accent-700 mb-1">{stat.value}</p>
              <p className="text-foreground-500 text-sm">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}